import curry from "ramda/es/curry";
import isFunction from "ramda-extension/es/isFunction";
export const resolveValue = curry((state, value)=>isFunction(value) ? value(state) : value);
